import React, { useRef, useState, useEffect } from 'react';
import './AudioPlayerBase.css';

const AudioPlayerSimple = ({
  audioSrc,
  avatarSrc,
}) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }

    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    if (!audioRef.current) return;

    setProgress(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    if (!audioRef.current) return;

    setDuration(audioRef.current.duration);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    setProgress(0);
  };

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  const formatTime = (time) => {
    if (!time || isNaN(time)) return '0:00';

    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');

    return `${minutes}:${seconds}`;
  };

  return (
    <div className="audio-player">
      <audio
        ref={audioRef}
        src={audioSrc}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={handleEnded}
        preload="metadata"
      />

      {avatarSrc && (
        <div className="audio-avatar">
          <img src={avatarSrc} alt="Avatar" />
        </div>
      )}

      <div className="audio-controls">
        <button
          className="audio-play-btn"
          onClick={togglePlay}
          aria-label={isPlaying ? 'Pausar áudio' : 'Reproduzir áudio'}
        >
          {isPlaying ? '❚❚' : '▶'}
        </button>

        <div className="audio-progress">
          <span className="audio-time">
            {formatTime(progress)}
          </span>

          <div className="audio-bar">
            <div
              className="audio-bar-fill"
              style={{
                width: duration
                  ? `${(progress / duration) * 100}%`
                  : '0%',
              }}
            />
          </div>

          <span className="audio-time">
            {formatTime(duration)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayerSimple;
